import { commentsGateway } from "@/gateways/commentsGateway";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { Comment, NewComment } from "./types";

export const useGetHouseComments = (houseId: number) => {
  const query = useQuery({
    queryKey: ["houseComments", houseId],
    queryFn: () => commentsGateway.getCommentsForHouse(houseId),
  });

  return {
    ...query,
    getHouseCommentsStatus: query.status,
    comments: query.data,
  };
};

export const useCreateHouseComment = (houseId: number) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (comment: NewComment) =>
      commentsGateway.createCommentForHouse(houseId, comment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["houseComments", houseId] });
    },
  });

  return {
    ...mutation,
    createHouseCommentStatus: mutation.status,
    createComment: mutation.mutate,
  };
};

export const useUpdateHouseComment = (houseId: number) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (comment: Comment) => commentsGateway.updateComment(comment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["houseComments", houseId] });
    },
  });

  return {
    ...mutation,
    updateHouseCommentStatus: mutation.status,
    updateComment: mutation.mutate,
  };
};

export const useDeleteHouseComment = (houseId: number) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (comment: Comment) => commentsGateway.deleteComment(comment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["houseComments", houseId] });
    },
  });

  return {
    ...mutation,
    deleteHouseCommentStatus: mutation.status,
    deleteComment: mutation.mutate,
  };
};
